import {Component, inject, OnInit, ViewChild} from '@angular/core';
import { EchoChannelService } from '../../sevices/echo-channel.service';
import {Observable, map, merge, tap, startWith, combineLatest, distinctUntilChanged, of, take} from 'rxjs';
import { UserNotificationService } from '../../sevices/user-notification.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

declare const $: any;
@Component({
  selector: 'lcms-spash-notif',
  templateUrl: './spash-notif.component.html',
  styleUrls: ['./spash-notif.component.scss'],
})
export class SpashNotifComponent{
  echo = inject(EchoChannelService)
  userNotif=inject(UserNotificationService)
  modalService=inject(NgbModal)
  sanitizer=inject(DomSanitizer);
  splashs : any[] = []
  selectedSlashIndex=0;
  itemsBean$:Observable<any>=this.echo.subjectSplash.asObservable();
  itemsUser$:Observable<any>=this.userNotif.getUserNotif().pipe(
    map((data:any)=>data?.data),
    map((data:any)=>{
      return data.filter((dt:any)=>dt?.type==='SPLASH')
    }),
  );
  items$ = combineLatest([this.itemsBean$, this.itemsUser$]).pipe(
    map(([beanData, userData]) => {
      // Traitement des données combinées de beanData et userData
      const combinedData = [];
      if (beanData) {
        combinedData.push(...beanData);
      }

      // Ajoutez les données de userData s'il n'est pas null
      if (userData) {
        combinedData.push(...userData);
      }

      if (combinedData.length > 0) {
        this.selectedSlashIndex = 0;
        this.splashs =combinedData;
        $('#splashModal').modal('show');
      }

      return combinedData;
    }),
    // tap((res) => console.log('data spals', res))
  ).subscribe();
  // items$ :Observable<any> =  merge(this.itemsBean$,this.itemsUser$).pipe(
  //
  //   map((data: any[]) => {
  //     if (data) {
  //       // Remove duplicates from the array
  //       return Array.from(new Set(data.map(item => JSON.stringify(item))))
  //         .map(item => JSON.parse(item));
  //     }
  //     return [];
  //   }),
  //   distinctUntilChanged(), // Ensures that only distinct data arrays are emitted
  //   tap((data: any) => {
  //     if (data.length > 0) {
  //       this.selectedSlashIndex = 0;
  //       this.splashs.push(...data);
  //       $('#splashModal').modal('show');
  //     }
  //     console.log('data splash', data);
  //   })
  // );



  next() {
    if (this.selectedSlashIndex <  this.splashs.length - 1) {
      this.selectedSlashIndex +=1;
    }
  }

  back() {
    if (this.selectedSlashIndex > 0) {
      this.selectedSlashIndex-=1;
    }
  }
  rm(item : any): void {
    this.echo.rmSpash(item);
    this.splashs = this.splashs.filter(data => data.id !== item.id);
    if(this.splashs.length !==0)  this.selectedSlashIndex = this.splashs.length - 1;
     if(this.splashs.length===0)  {
       $('#splashModal').modal('hide');
       this.selectedSlashIndex = 0
     this.splashs =[]
       this.echo.splash = []
     }
  }
  closeModal(){
    $('#splashModal').modal('hide');
  }

  santizeHTML(value:string):SafeHtml{
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

}
